<template>
  <div>
    <TirPmDropdown
      class="dropdown"
      label=""
      :placeholder="'Показывать по ' + (countElements ? countElements : '')"
      :options="optionDropdown"
      :selected-option="selectOption"
      :size="TirPmDropdownSizeEnum.Light"
      popover-width="auto"
      option-list-scroll-height="11rem"
      :popover-position="PopoverPositionEnum.Bottom"
    >
      <template #optionList="{ option }">
        <div class="option-block" @click="selectedOptions(option)">
          <p class="option">{{ option.Id }}</p>
        </div>
      </template>
    </TirPmDropdown>
  </div>
</template>
<script lang="ts" setup>
import { ITirPmDropdownOption, PopoverPositionEnum, TirPmDropdown, TirPmDropdownSizeEnum } from "tir-components";
import { PropType, ref } from "vue";

const emit = defineEmits<{
  (e: "update:countElements", count: number): void;
}>();

const props = defineProps({
  countElements: { type: Number as PropType<number> },
  /**
   * Опции для дропдауна
   */
  options: { type: Array as PropType<number[]> },
});
const selectOption = ref();

const selectedOptions = (value: object) => {
  selectOption.value = value;
  emit("update:countElements", selectOption.value.Id);
};

const optionDropdown: ITirPmDropdownOption[] = props.options.map((x) => {
  return { Id: x }; // Создаем объект с полем Id
});
</script>
<style lang="scss">
.option-block {
  display: flex;
  align-items: center;
  justify-content: center;
}
.option {
  display: flex;
  justify-content: center;
  width: 5rem;
}

.dropdown {
  display: flex;
  .tir-popover_element .tir-pm-dropdown__target .tir-pm-dropdown__area {
    border: none;
    width: 100% !important;
  }
  .tir-pm-dropdown__desc-select .tir-pm-dropdown__selected-item .tir-pm-dropdown__placeholder {
    font-size: 0.875rem;
    color: var(--text-primary, #272d37);
    font-weight: 500;
  }
}
</style>
